module.exports = __webpack_public_path__ + "img/orbit-banner-mobile-m.4294a6f1.png";